module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"loading":"Načítám…","no_events_found":"Nebyly nalezeny žádné odpovídající termíny!"},"sk":{"loading":"Načítam…","no_events_found":"Neboli nájdené žiadne odpovedajúce termíny!"},"en":{"loading":"Loading…","no_events_found":"No matching terms found!"}}')
  delete Component.options._Ctor
}
